import type { Ctx } from '@/model/ctx';
/** Keyed timers standing in for the reference's `this._tt` / `this._rp` and fire-and-forget setTimeouts. */
export function createTimers(): Ctx['timers'] & { dispose(): void } {
  const timeouts = new Map<string, ReturnType<typeof setTimeout>>();
  const intervals = new Map<string, ReturnType<typeof setInterval>>();
  let n = 0;
  return {
    after(ms, fn, key) {
      const k = key ?? '__t' + n++;
      const prev = timeouts.get(k);
      if (prev) clearTimeout(prev);
      timeouts.set(
        k,
        setTimeout(() => {
          timeouts.delete(k);
          fn();
        }, ms),
      );
    },
    every(ms, fn, key) {
      const prev = intervals.get(key);
      if (prev) clearInterval(prev);
      intervals.set(key, setInterval(fn, ms));
    },
    clear(key) {
      const t = timeouts.get(key);
      if (t) {
        clearTimeout(t);
        timeouts.delete(key);
      }
      const i = intervals.get(key);
      if (i) {
        clearInterval(i);
        intervals.delete(key);
      }
    },
    dispose() {
      for (const t of timeouts.values()) clearTimeout(t);
      for (const i of intervals.values()) clearInterval(i);
      timeouts.clear();
      intervals.clear();
    },
  };
}
